<template>
  <BaseCard>
    <BaseCardBody clear-padding>
      <dl>
        <div class="px-4 py-5 sm:px-6 border-b sm:grid sm:grid-cols-4 sm:gap-4 sm:items-center">
          <dt class="text-sm font-medium text-gray-800">Invoice</dt>
        </div>
        <div
          v-if="hasInvoice"
          class="bg-gray-50 px-4 py-5 sm:grid sm:grid-cols-4 sm:gap-4 sm:px-6 sm:items-center rounded-b"
        >
          <dd class="mt-1 text-sm text-gray-900 sm:mt-0 space-y-1">
            <RouterLink v-if="invoiceLink" :to="invoiceLink">
              Invoice #{{ invoice.number }}
            </RouterLink>
            <span v-else-if="invoice">Invoice #{{ invoice.number }}</span>
            <span v-else>Invoice details not available</span>
          </dd>
        </div>
        <div
          v-else
          class="bg-gray-50 px-4 py-5 sm:grid sm:grid-cols-4 sm:gap-4 sm:px-6 sm:items-center rounded-b"
        >
          <dd class="mt-1 text-sm text-gray-900 sm:mt-0 space-y-1">
            <BaseVeeForm :action="createInvoice" v-slot="{ isPending, invalid }">
              <BaseButton :disabled="isPending || invalid || hasInvoice" primary>
                Create invoice
              </BaseButton>
              <ValidationProvider rules="required" name="order" slim vid="order">
                <template #default="{ errors }">
                  <BaseFormGroup>
                    <BaseFormInput type="hidden" :value="orderId" />
                    <BaseFormInlineMessage v-if="errors.length" danger>
                      {{ errors[0] }}
                    </BaseFormInlineMessage>
                  </BaseFormGroup>
                </template>
              </ValidationProvider>
            </BaseVeeForm>
          </dd>
        </div>
      </dl>
    </BaseCardBody>
  </BaseCard>
</template>

<script>
import makeOrderInvoiceModule from '@/store/modules/orderInvoice';

export default {
  props: {
    orderId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      modulePath: ['ui', `order:${this.orderId}:invoice`],
    };
  },
  computed: {
    order() {
      return this.$store.state.entities.orders.byId[this.orderId];
    },
    accountRelation() {
      if (!this.order) {
        return null;
      }
      return this.$store.state.entities.accountRelations.byId[this.order.accountRelationUuid];
    },
    relatedAccount() {
      if (!this.accountRelation) {
        return null;
      }
      return this.$store.state.entities.accounts.byId[this.accountRelation.related_account_uuid];
    },
    invoiceId() {
      return this.$store.state.ui?.[`order:${this.orderId}:invoice`]?.invoiceId || null;
    },
    invoice() {
      if (!this.invoiceId) {
        return null;
      }

      return this.$store.state.entities.invoices.byId[this.invoiceId];
    },
    hasInvoice() {
      return typeof this.invoice === 'object' && this.invoice !== null;
    },
    invoiceLink() {
      if ((!this.relatedAccount && !this.order) || !this.hasInvoice) {
        return null;
      }

      return {
        name: 'accounts.accountId.invoices.invoiceUuid',
        params: {
          accountId: this.relatedAccount.id || this.order.accountUuid,
          invoiceUuid: this.invoice.uuid,
        },
      };
    },
  },
  created() {
    this.registerModule();
    this.fetchInvoice();
  },
  destroyed() {
    this.unregisterModule();
  },
  methods: {
    registerModule() {
      if (!this.$store.hasModule(this.modulePath)) {
        this.$store.registerModule(this.modulePath, makeOrderInvoiceModule(this.orderId));
      }
    },
    unregisterModule() {
      if (this.$store.hasModule(this.modulePath)) {
        this.$store.unregisterModule(this.modulePath);
      }
    },
    async fetchInvoice() {
      try {
        await this.$store.dispatch({
          type: `${this.modulePath.join('/')}/fetchInvoice`,
        });
      } catch (error) {
        //
      }
    },
    async createInvoice() {
      try {
        await this.$store.dispatch({
          type: `${this.modulePath.join('/')}/storeInvoice`,
        });

        return Promise.resolve();
      } catch (error) {
        return Promise.reject(error);
      }
    },
  },
};
</script>
